import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateCarrierProducts, getCarrierProductCommissions } from '@/modules/CarrierProduct/gql/carrier-product.gql'

import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import { showErrors } from '@/utils/snack'
import { CarrierProductCommission } from '@/modules/CarrierProduct/interfaces/carrier-product-commission'

@Component
export default class SearchCarrierProduct extends Vue {
  candidatesCarrierProduct: CarrierProduct[] = []
  candidatesCommission: CarrierProductCommission[] = []

  get candidatesCarrierProductNameOptions () {
    return this.candidatesCarrierProduct.map(item => {
      return item.name
    })
  }

  get candidatesCarrierProductOptions () {
    return this.candidatesCarrierProduct.map(item => {
      return {
        id: +item.id,
        name: item.name
      }
    })
  }

  get candidatesCommissionOptions () {
    return this.candidatesCommission
  }

  async mounted () {
    this.getCandidateCarrierProducts()
  }

  async getCandidateCarrierProducts (val?: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateCarrierProducts,
        variables: {
          filter: {
            name: val || ''
          },
          paging: null
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesCarrierProduct = this.$R.sortBy(this.$R.compose(this.$R.toLower, this.$R.prop('name')))(result.data.getCarrierProducts.carrierProducts)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getCandidateCommissions (productId: number) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCarrierProductCommissions,
        variables: {
          carrierProductId: productId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }

      this.candidatesCommission = this.$R.sortBy(this.$R.prop('commission'))(
        result.data.getCarrierProductCommissions.map((commission: CarrierProductCommission) => {
          return {
            ...commission,
            commission: +commission.commission
          }
        })
      )
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
